// src/pages/MeetingRoomPage.jsx

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BookingForm from "../components/BookingForm";
import MeetingRoomCalendar from "../components/MeetingRoomCalendar";
import { useSnackbar } from "notistack"; // for toast
import { getRoomById } from "../services/roomService"; // פונקציה להחזרת פרטי החדר

function MeetingRoomPage() {
  // short English comments only
  const { roomId } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  // new state for room info (e.g. name)
  const [room, setRoom] = useState(null);

  // NEW: selectedDate state - to share between BookingForm & MeetingRoomCalendar
  const [selectedDate, setSelectedDate] = useState(null);

  // pass a callback to BookingForm that can show toast and refresh calendar
  const handleBookingSuccess = (msg) => {
    enqueueSnackbar(msg, { variant: "success" });
    setRefreshKey((prev) => prev + 1);
  };

  const handleBookingError = (msg) => {
    enqueueSnackbar(msg, { variant: "error" });
  };

  // fetch room data to display its name
  useEffect(() => {
    getRoomById(roomId)
      .then((roomData) => {
        setRoom(roomData);
      })
      .catch((err) => {
        console.error("Error fetching room data:", err);
      });
  }, [roomId]);

  return (
    <div style={{ margin: 20 }}>
      <h2>
        {room && room.name}
      </h2>

      <BookingForm
        roomId={roomId}
        onBookingSuccess={handleBookingSuccess}
        onBookingError={handleBookingError}

        // Pass down the shared date states:
        selectedDate={selectedDate}           // current chosen date
        onDateChange={setSelectedDate}        // function to update it
      />

      <MeetingRoomCalendar
        roomId={roomId}
        refreshKey={refreshKey}
        chosenDate={selectedDate}    // pass the chosen date to the calendar
      />
    </div>
  );
}

export default MeetingRoomPage;